import { render, staticRenderFns } from "./EcologicalUnitABMComponent.vue?vue&type=template&id=5c4414de&scoped=true"
import script from "./EcologicalUnitABMComponent.js?vue&type=script&lang=js&external"
export * from "./EcologicalUnitABMComponent.js?vue&type=script&lang=js&external"
import style0 from "./EcologicalUnitABMComponent.vue?vue&type=style&index=0&id=5c4414de&prod&scoped=true&lang=scss"
import style1 from "./EcologicalUnitABMComponent.vue?vue&type=style&index=1&id=5c4414de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4414de",
  null
  
)

export default component.exports